<!-- subnav.component.html -->
@if (subNavItems.length > 0) {
<div>
  <nav class="px-0 py-0">
    <ul class="flex select-none relative list-none gap-0">
      @for (item of subNavItems; track $index) {
      <li class="text-[0.85rem] subnav-item capitalize cursor-pointer px-3 py-2
                     transition-all duration-300 ease-out z-10 relative select-none group"
        [class.active]="activeItem === item" [ngClass]="{
                'text-primary-900 font-medium': activeItem === item,
                'text-grey-400 font-normal hover:text-grey-600 transition-colors duration-300 ease-out': activeItem !== item
              }" (click)="setActive(item)" [routerLink]="item.link || null">

        {{ item.label }}
      </li>
      }

      <!-- Active Indicator -->
      <span class="absolute rounded-t-3xl h-9.5 transition-all duration-200 ease-out z-0 pointer-events-none"
        [ngClass]="indicatorClass" [style.left]="indicatorPosition" [style.width]="indicatorWidth">
      </span>
    </ul>
  </nav>
</div>
}